import {
  Box,
  Button,
  ButtonGroup,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  StatDownArrow,
  StatUpArrow,
  Link as StyledLink,
  Table,
  Tag,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
  Center,
  Icon,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import {
  MdAdd,
  MdArrowDownward,
  MdArrowUpward,
  MdImage,
  MdLink,
  MdSettings,
} from "react-icons/md";
import { Img } from "react-image";
import { Link } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { ICreateStoryFormValues, StoryForm } from "../../forms";
import {
  StoriesDocument,
  Story,
  useCreateStoryMutation,
  useDeleteStoryMutation,
  useMoveStoryDownMutation,
  useMoveStoryUpMutation,
  useStoriesQuery,
  useUpdateStoryMutation,
} from "../../graphql";
import { formatDateTime } from "../../utils";

const Stories: React.FC = () => {
  const toast = useToast();
  const [currentItem, setCurrentItem] = useState<Story>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data, loading } = useStoriesQuery({
    variables: {
      iconWidth: 100,
    },
  });
  const [create] = useCreateStoryMutation();
  const [update] = useUpdateStoryMutation();
  const [deleteItem] = useDeleteStoryMutation();

  const [moveStoryDown] = useMoveStoryDownMutation();
  const [moveStoryUp] = useMoveStoryUpMutation();

  const handleCreatEvent = async (data: ICreateStoryFormValues) => {
    currentItem
      ? await update({
          variables: {
            id: currentItem.id,
            mediaKey: data.icon.key,
            title: data.title,
            isActive: data.isActive === "1",
          },
          refetchQueries: [
            {
              query: StoriesDocument,
              variables: {
                iconWidth: 100,
              },
            },
          ],
        })
      : await create({
          variables: {
            mediaKey: data.icon.key,
            title: data.title,
          },
          refetchQueries: [
            {
              query: StoriesDocument,
              variables: {
                iconWidth: 100,
              },
            },
          ],
        });

    onClose();

    setCurrentItem(null);
  };

  const handleDeleteEvent = async (id: number) => {
    await deleteItem({
      variables: {
        id: id,
      },
      refetchQueries: [
        {
          query: StoriesDocument,
          variables: {
            iconWidth: 100,
          },
        },
      ],
    });

    onClose();
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Shto një bllokmedia</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <StoryForm
              onSubmit={(data) => {
                handleCreatEvent(data);
              }}
              initialValues={{
                icon: currentItem?.icon,
                isActive: currentItem?.isActive ? "1" : "0",
                title: currentItem?.rawTitle
                  ? {
                      sq: currentItem.rawTitle.sq,
                      en: currentItem.rawTitle.en,
                      mk: currentItem.rawTitle.mk,
                    }
                  : { sq: "", en: "", mk: "" },
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
      <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
        <Title title="Bllokmedia">
          <Button
            rightIcon={<MdAdd />}
            colorScheme="blue"
            variant="outline"
            size="sm"
            onClick={onOpen}
          >
            Shto
          </Button>
        </Title>

        <Table variant="striped" size="sm">
          <Thead>
            <Tr>
              <Th>Ikona</Th>
              <Th width="300px">Titulli</Th>
              <Th>Numri i faqeve</Th>
              <Th>Statusi</Th>
              <Th>Autori</Th>
              <Th>Ndryshimi i fundit</Th>
              <Th width="60px" isNumeric></Th>
              <Th width="30px" isNumeric></Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.stories?.map((item, index) => (
              <Tr key={item.id}>
                <Td width={"100px"}>
                  <Img
                    src={item.icon.url}
                    alt={item.title}
                    style={{
                      height: "50px",
                      width: "50px",
                      objectFit: "cover",
                      borderRadius: "25px",
                    }}
                    loader={
                      <>
                        <Center
                          width={50}
                          height={50}
                          background="blue.50"
                          color="blue.400"
                          style={{
                            borderRadius: "25px",
                          }}
                        >
                          <Icon as={MdImage} fontSize={40} />
                        </Center>
                      </>
                    }
                  />
                </Td>
                <Td>{item.title}</Td>
                <Td>
                  <StyledLink fontWeight={"bold"}>
                    <Icon as={MdLink} fontSize={20} mr={2} />

                    <Link to={`/story/${item.id}`}>
                      {item.items.length} faqe
                    </Link>
                  </StyledLink>
                </Td>
                <Td>
                  {item.isActive ? (
                    <Tag colorScheme="green">Aktive</Tag>
                  ) : (
                    <Tag colorScheme="gray">Jo aktive</Tag>
                  )}
                </Td>
                <Td>
                  <AccountAvatar account={item.author} role={false} size="sm" />
                </Td>
                <Td>{formatDateTime(item.updatedAt)}</Td>
                <Td>
                  <ButtonGroup size="sm" isAttached variant="outline">
                    <IconButton
                      aria-label="Add to friends"
                      disabled={index === 0}
                      icon={
                        <MdArrowUpward
                          onClick={() => {
                            if (index === 0) {
                              toast({
                                status: "info",
                                description: "Veprimi nuk është i mundur!",
                              });
                            }

                            moveStoryUp({
                              variables: {
                                id: item.id,
                              },
                              refetchQueries: [
                                {
                                  query: StoriesDocument,
                                  variables: {
                                    iconWidth: 100,
                                  },
                                },
                              ],
                            });
                          }}
                        />
                      }
                    />
                    <IconButton
                      aria-label="Add to friends"
                      disabled={index === data.stories.length - 1}
                      icon={
                        <MdArrowDownward
                          onClick={() => {
                            if (index === data.stories.length - 1) {
                              toast({
                                status: "info",
                                description: "Veprimi nuk është i mundur!",
                              });
                            }

                            moveStoryDown({
                              variables: {
                                id: item.id,
                              },
                              refetchQueries: [
                                {
                                  query: StoriesDocument,
                                  variables: {
                                    iconWidth: 100,
                                  },
                                },
                              ],
                            });
                          }}
                        />
                      }
                    />
                  </ButtonGroup>
                </Td>
                <Td isNumeric>
                  <Menu>
                    <MenuButton
                      px={2}
                      py={0.5}
                      transition="all 0.2s"
                      _focus={{ boxShadow: "outline" }}
                    >
                      <MdSettings />
                    </MenuButton>
                    <MenuList>
                      <MenuItem
                        onClick={() => {
                          setCurrentItem(item as Story);
                          onOpen();
                        }}
                      >
                        Redakto
                      </MenuItem>
                      <MenuItem onClick={() => handleDeleteEvent(item.id)}>
                        Fshi
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </>
  );
};

export default Stories;
